import { render, staticRenderFns } from "./fxqyone.vue?vue&type=template&id=015421f5&scoped=true&"
import script from "./fxqyone.vue?vue&type=script&lang=js&"
export * from "./fxqyone.vue?vue&type=script&lang=js&"
import style0 from "./fxqyone.vue?vue&type=style&index=0&id=015421f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015421f5",
  null
  
)

export default component.exports